import React, {
  useCallback,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import { Card, Dropdown } from "react-bootstrap";

// Components
import ChatList from "./ChatList";

// Utils
import { fetchWithToken } from "../../api/fetch";
import { AuthContext } from "../../context/AuthContext";
import debounce from "../../utils/debounce";
import { ChatContext } from "../../context/chat/ChatContext";

const ChatUsers = () => {
  const [filter, setFilter] = useState("Todos"); // Filtro de los chats
  const [searchResults, setSearchResults] = useState([]); // Resultados de la búsqueda
  const [isSearching, setIsSearching] = useState(false); // Indica si se está buscando
  const searchInputRef = useRef(null); // Referencia al input de búsqueda


  // Información del usuario autenticado
  const { auth } = useContext(AuthContext);
  const { uid } = auth;

  // Contexto del chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  // Filtros de los chats
  const groupFilters = [
    "Todos",
    "Mis Chats",
    "No leídos",
    "Etiquetados",
    "Pagos",
  ];

  // Mapeo de los filtros
  const filterMap = {
    "Mis Chats": uid,
    "No leídos": "unread",
    Etiquetados: "tag",
    Pagos: "pagos",
  };

  const searchChat = useCallback(
    debounce(async (word) => {
      if (word === "") {
        setSearchResults({});
        setIsSearching(false);
        return;
      }
      const currentFilterValue = filterMap[filter] || "Todos"; // Usar el filtro actualizado

      setIsSearching(true);

      const resp = await fetchWithToken(
        "sms/search",
        { word, type: currentFilterValue },
        "POST"
      );

      if (resp.ok)
        setSearchResults([...resp.usuarios, ...resp.messages, ...resp.notes]);
    }, 600),
    [filter]
  );
  // Función para manejar el cambio de filtro
  const handleFilterChange = (selectedFilter) => {
    setFilter(selectedFilter);

    // Limpiar el contenido del input de búsqueda
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  return (
    <Card
      className={`border border-light rounded ${
        activeChat ? "d-none d-md-block" : ""
      }`}
      style={{ height: "calc(100vh - 120px)", width: "100%" }}
    >
      <Card.Body className="p-0">
        <div className="d-flex justify-content-between mx-3 my-3">
          <h3>Chats</h3>

          <Dropdown>
            <Dropdown.Toggle className="arrow-none" variant="light">
              <i className="uil uil-filter me-1" />
              <span className="font-14">{filter}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {groupFilters.map((group, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => handleFilterChange(group)}
                >
                  {group}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="app-search mx-3 mb-2">
          <div className="d-flex align-items-center">
            <div className="form-group position-relative flex-grow-1">
              <input
                ref={searchInputRef}
                type="text"
                className="form-control"
                placeholder="Busca personas o mensajes..."
                onKeyUp={(e) => searchChat(e.target.value)}
              />
              <span className="mdi mdi-magnify search-icon" />
            </div>
          </div>
        </div>

        <ChatList
          filter={filter}
          searchResults={searchResults}
          isSearching={isSearching}
        />
      </Card.Body>
    </Card>
  );
};

export default ChatUsers;
